import { ReactElement, useMemo } from 'react'
import { Box } from '@mui/system'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { Form } from 'react-final-form'
import { DialogActions, DialogContent } from '@mui/material'
import { required } from 'src/shared/form/validation/validators'
import { AutoCompleteField } from 'src/shared/form/control/AutoCompleteField'
import { PrimaryButton, SecondaryButton } from 'src/shared/button/Buttons'
import { createDecorators } from 'src/shared/form/utils/decorators'
import { Option } from 'src/shared/form/control'

interface Props {
  userPermissionsOptions: Option[]
  userPermission: string
  onConfirm: (newUserPermission: string) => void
  onCancel: () => void
}

interface EditUserFormValues {
  permissionOptionCode: string | undefined
}

const decorators = createDecorators()

export const EditUserPermissionModal = ({
  userPermissionsOptions,
  userPermission,
  onConfirm,
  onCancel,
}: Props): ReactElement => {
  const { getMessage } = useMessageSource()

  const initialValues: EditUserFormValues = useMemo(
    () => ({
      permissionOptionCode: userPermission,
    }),
    [userPermission],
  )

  const handleSubmitLocal = async (values: EditUserFormValues): Promise<any> => {
    if (values.permissionOptionCode) {
      return onConfirm(values.permissionOptionCode)
    }
  }

  return (
    <Box>
      <Form<EditUserFormValues>
        initialValues={initialValues}
        onSubmit={handleSubmitLocal}
        decorators={decorators}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} noValidate>
            <DialogContent>
              <AutoCompleteField
                required
                label={getMessage('label.select.permission')}
                name="permissionOptionCode"
                options={userPermissionsOptions}
                validate={required()}
              />
            </DialogContent>
            <DialogActions>
              <SecondaryButton messageKey={'button.cancel'} onClick={onCancel} />
              <PrimaryButton messageKey={'button.add'} type="submit" />
            </DialogActions>
          </form>
        )}
      />
    </Box>
  )
}
